/**
 * How a saved cycle's type reads back into the fertility-treatments intake.
 *
 * The type picker offers IVF and ICSI as one option (`ivf_icsi`), so for the
 * selection both must resolve to it, or the saved choice matches no visible
 * button. A treatment row is different: it keeps the cycle's own type, so the
 * IVF + ICSI screen finds an existing cycle instead of adding a blank one, and
 * saves an ICSI cycle back as ICSI.
 */
const PICKER_TYPE_BY_CYCLE_TYPE: Record<string, string> = {
  ivf: "ivf_icsi",
  icsi: "ivf_icsi",
  iui: "iui",
  fet: "fet",
  oi: "oi",
  meds_only: "meds_only",
  timed_intercourse: "timed_intercourse",
  unknown: "unknown",
  other: "other",
  egg_freezing: "egg_freezing",
  embryo_freezing: "embryo_freezing",
  sperm_freezing: "sperm_freezing",
};

/** The picker option a saved cycle type selects. */
export function pickerTypeForCycleType(cycleType: string): string {
  return PICKER_TYPE_BY_CYCLE_TYPE[cycleType] ?? cycleType;
}

/** The type a saved cycle's treatment row carries. */
export function treatmentTypeForCycleType(cycleType: string): string {
  if (cycleType === "ivf" || cycleType === "icsi") return cycleType;
  return pickerTypeForCycleType(cycleType);
}
